<ng-content />
<div class="vds-sub-nav-item-background"></div>
